import {
  ClientSideRowModelModule,
  ExternalFilterModule,
  PaginationModule,
  ValidationModule,
  CellStyleModule,
  RowApiModule,
  RowAutoHeightModule,
  RenderApiModule,
} from 'ag-grid-community';
import {
  LicenseManager,
  ServerSideRowModelModule,
  ServerSideRowModelApiModule,
  ContextMenuModule,
  SetFilterModule,
} from 'ag-grid-enterprise';

import { appConfig } from '@app/config/appConfig';

const {
  thirdParties: { agGridLicenseKey },
} = appConfig;

LicenseManager.setLicenseKey(agGridLicenseKey);

export const AG_GRID_MODULES = [
  ClientSideRowModelModule,
  ExternalFilterModule,
  PaginationModule,
  ValidationModule,
  CellStyleModule,
  RowApiModule,
  RowAutoHeightModule,
  RenderApiModule,
  ServerSideRowModelModule,
  ServerSideRowModelApiModule,
  ContextMenuModule,
  SetFilterModule,
];
